import ApiClient from '../../../../base/api';
import { SimilarVacancy } from './interfaces';

const apiClient = new ApiClient();

export const vacanciesApi = {
    getSimilarVacancies: (vacancyId: string) => apiClient.get<SimilarVacancy[]>(`/api/vacancies/${vacancyId}/similar`),
    favoritesToggle: (vacancyId: number, value: boolean) =>
        apiClient.post(`/api/vacancies/${vacancyId}/favorite`, { favorite: value }),
};
